




























import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({})
export default class Layout extends Vue {
  public opened: boolean = false;

  get hamburgerVisible() {
    return this.$slots.header && this.$slots.header.length;
  }

  public toggle() {
    this.opened = !this.opened;
  }

  public close() {
    this.opened = false;
  }
}
